<template>
  <v-app>
    <v-card color="grey lighten-4" flat tile>
      <v-toolbar color="primary" dark fixed app>
        <v-app-bar-nav-icon
          v-if="isTablet"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
        <v-toolbar-title>รายการนับสินค้า</v-toolbar-title>
      </v-toolbar>
    </v-card>

    <v-row no-gutters class="no-wrap">
      <template v-if="isTablet">
        <v-navigation-drawer temporary absolute v-model="drawer">
          <v-list>
            <v-list-item class="ml-4 d-flex justify-center" link>
              <v-list-item-avatar>
                <v-img :src="profilePicture"></v-img>
              </v-list-item-avatar>
            </v-list-item>

            <v-list-item link>
              <v-list-item-content>
                <div>
                  <h3>
                    {{ empCode || 'Username' }}
                  </h3>
                </div>
                <v-list-item-subtitle @click="logout">
                  ออกจากระบบ
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list dense nav>
            <template v-for="item in items">
              <v-list-item
                v-if="!item.isGroup"
                v-bind:key="item.title"
                :class="[
                  {
                    'v-list-item--active': item.name === $route.name,
                  },
                ]"
                color="primary"
                @click="onClickMenu(item.name)"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>
                    <div v-html="item.title"></div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-group
                v-else
                v-model="openMenuAiImageDetection"
                v-bind:key="`group-${item.title}`"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      <div v-html="item.title"></div>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="group in item.group"
                  v-bind:key="group.title"
                  :class="[
                    {
                      'v-list-item--active':
                        group.name === $route.name,
                    },
                  ]"
                  color="primary"
                  @click="onClickMenu(group.name)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <div v-html="group.title"></div>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>
          </v-list>
        </v-navigation-drawer>
      </template>
      <template v-else>
        <v-navigation-drawer permanent>
          <v-list>
            <v-list-item class="ml-4 d-flex justify-center" link>
              <v-list-item-avatar>
                <v-img :src="profilePicture"></v-img>
              </v-list-item-avatar>
            </v-list-item>

            <v-list-item link>
              <v-list-item-content>
                <div>
                  <h3>
                    {{ empCode || 'Username' }}
                  </h3>
                </div>
                <v-list-item-subtitle @click="logout">
                  ออกจากระบบ
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list dense nav>
            <template v-for="item in items">
              <v-list-item
                v-if="!item.isGroup"
                v-bind:key="item.title"
                :class="[
                  {
                    'v-list-item--active': item.name === $route.name,
                  },
                ]"
                color="primary"
                @click="onClickMenu(item.name)"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>
                    <div v-html="item.title"></div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-group
                v-else
                v-model="openMenuAiImageDetection"
                v-bind:key="`group-${item.title}`"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      <div v-html="item.title"></div>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="group in item.group"
                  v-bind:key="group.title"
                  :class="[
                    {
                      'v-list-item--active':
                        group.name === $route.name,
                    },
                  ]"
                  color="primary"
                  @click="onClickMenu(group.name)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <div v-html="group.title"></div>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>
          </v-list>
        </v-navigation-drawer>
      </template>
      <v-col>
        <v-container>
          <slot></slot>
        </v-container>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import VERSION from '@/enums/version'

export default {
  computed: {
    ...mapState({
      me: (state) => state.me.data,
    }),

    profilePicture() {
      return this?.me?.image_url ?? ''
    },

    empCode() {
      return this?.me?.emp_code ?? ''
    },

    isTablet() {
      return (
        this.$vuetify.breakpoint.name === 'xs' ||
        this.$vuetify.breakpoint.name === 'sm'
      )
    },

    isShowNav() {
      return this.isTablet ? this.drawer : true
    },

    stockView() {
      return this.me?.permission?.stock_view
    },

    items() {
      if (this.stockView) {
        return [
          {
            title: 'หน้าหลัก',
            icon: 'mdi-view-dashboard',
            name: 'Dashboard',
          },
          {
            title: `AI ตรวจสอบรูปภาพ <div class="badge-beta">${VERSION.AI}</div>`,
            icon: 'mdi-image-search',
            name: 'AiImageDetection',
          },
          // Hide group menu for now
          //   {
          //     title: `AI ตรวจสอบรูปภาพ <div class="badge-beta">${VERSION.AI}</div>`,
          //     icon: 'mdi-image-search',
          //     name: 'AiImageDetection',
          //     active: true,
          //     isGroup: true,
          //     group: [
          //       {
          //         title: 'ตรวจสอบทั้งหมด',
          //         name: 'AiImageDetection',
          //       },
          //       {
          //         title: 'ตรวจสอบเฉพาะ iPhone',
          //         name: 'AiImageDetectionIPhone',
          //       },
          //     ],
          //   },
        ]
      }
      return [
        {
          title: 'Stock Card',
          icon: 'mdi-file-document',
          name: 'StockCard',
        },
      ]
    },

    openMenuAiImageDetection() {
      return ['AiImageDetection', 'AiImageDetectionIPhone'].includes(
        this.$route.name,
      )
    },
  },

  watch: {
    group() {
      this.drawer = false
    },
  },

  data() {
    return {
      drawer: false,
      group: null,
      username: this.$route.params.username,

      // Mockup
      open: null,
    }
  },

  methods: {
    onClickMenu(name) {
      this.$router.push({
        name: name,
      })
    },
    logout() {
      this.$store.dispatch('auth/logout')
    },
  },
}
</script>

<style>
.container {
  width: 100%;
  padding: 12px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 960px) {
  .container {
    max-width: 890px;
  }
}
@media (min-width: 1264px) {
  .container {
    max-width: 1170px;
  }
}
@media (min-width: 1904px) {
  .container {
    max-width: 1650px;
  }
}

.no-wrap {
  flex-wrap: nowrap;
}

.v-list--nav .v-list-item__title {
  text-align: left !important;
}

.badge-beta {
  display: inline;
  margin-left: 4px;

  color: #ff4d4f;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  padding: 0px 4px;
  border-radius: 4px;

  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon {
  min-width: fit-content !important;
}
.v-application--is-ltr
  .v-list-item__icon:last-of-type:not(:only-child) {
  margin-left: 8px !important;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 8px !important;
}

.v-application--is-ltr
  .v-list--dense.v-list--nav
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 48px !important;
}

.v-list--dense .v-list-item .v-list-item__title {
  line-height: 24px !important;
}
</style>
